import { ShieldCheck } from "lucide-react";

import { verifiedByText, type ClaimDecider } from "~/lib/shared/cco-claims";

/**
 * The shield badge on a verified credential: who verified it and, when a
 * date was given, the month and year.
 */
export function VerifiedBadge({
  decider,
  date,
}: {
  decider: ClaimDecider;
  date: string | null;
}): React.JSX.Element {
  return (
    <span className="mt-2 inline-flex items-center gap-1 rounded-full border border-green-200 bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700">
      <ShieldCheck aria-hidden className="size-3 shrink-0" />
      {verifiedByText(decider, date)}
    </span>
  );
}
